import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ScrollAnimation from 'react-animate-on-scroll';
import './styles.css';
import ReadMore from '../ReadMore';

const Show = props => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

function LayoutIconTextRow(props) {
  const { column } = props.content;
  return (
    <div className={'two-collumns-content'}>
      <Container>
        <Row>
          {column.map((row, i) => {
            return (
              <Show key={i}>
                <Col md={2} xs={12}>
                  <ScrollAnimation animateIn="fadeInUp" animateOut="fadeOut">
                    <div className={'icon-holder'}>
                      <img src={row.icon.url} alt={row.icon.alt} />
                      {/* <i className={`icons icon-${row.icon}`} /> */}
                    </div>
                  </ScrollAnimation>
                </Col>
                <Col md={4} xs={12}>
                  {row && (
                    <ScrollAnimation animateIn="fadeInUp" animateOut="fadeOut">
                      <h3>{row.title}</h3>
                      <p dangerouslySetInnerHTML={{ __html: row.content }} />
                      {row.link && (
                        <ReadMore link={row.link}>{row.button_text}</ReadMore>
                      )}
                    </ScrollAnimation>
                  )}
                </Col>
              </Show>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}

export default LayoutIconTextRow;
